import { db } from '../';


export const deleteMindSweep = ({ mindSweepKey }) => {
  return db.collection('mind-sweeps').doc(mindSweepKey).delete();
};